export const BU_ACCESS_RIGHT = {
  ASSIGN_STAFF: 1,
  ALL_MEMBER_MANAGEMENT: 2,
  EDIT_OTHER_MEMBER_MANAGEMENT: 7,
  EDIT_ROLE_NAME: 8,
  ADD_CREATE_BU_MEMBER: 9,
  REMOVE_BU_MEMBER: 10,
  ALL_GENERAL_SETTING: 3,
  EDIT_OTHER_GENERAL_SETTING: 11,
  EDIT_BU_GENERAL_SETTING: 12,
  DELETE_BU: 13,
  MANAGE_JOB_DOCUMENT: 4,
  ALL_BU_APP_MANAGEMENT: 5,
  EDIT_ORHTER_MEMBER_BU_APP_MANAGEMENT: 14,
  ACCESS_APP: 15,
  LEAVE_BU: 6,
};

export const CORP_ACCESS_RIGHT = {
  INFORMATION_MANAGEMENT: 1,
  EDIT_OTHER_MEMBER_INFORMATION: 5,
  VIEW_COMPANY_INFORMATION: 6,
  CRUD_COMPANY_INFORMATION: 7,
  PUBLISH_JOB_LISTING: 8,
  DELETE_CORP_ACCOUNT: 9,
  ACCOUNT_MANAGEMENT: 2,
  VIEW_CORPORATION_ACCOUNT_INFORMATION: 10,
  EDIT_CORPORATION_INFORMATION: 11,
  EDIT_CORPORATION_CALENDAR: 12,
  MEMBER_MANAGEMENT: 3,
  EDIT_OTHER_MEMBER_MANAGEMENT: 13,
  EDIT_OTHER_ROLE_NAMES: 14,
  INVITE_CORPORATION_MEMBER: 15,
  REMOVE_CORPORATION_MEMBER: 16,
  LEAVE_CORPORATION: 4,
};

/**
 * Use prefix 100 for OPS NAVI access right
 * For example 1009, the original access right id = 9
 */

export const OPS_NAVI_ACR_PREFIX = 100;

export const combineOpsNaviACRWithPrefix = (acrId: number) => {
  return Number(`${OPS_NAVI_ACR_PREFIX}${acrId}`);
};

export const OPSNAVI_ACCESS_RIGHT = {
  TAGS: combineOpsNaviACRWithPrefix(9), // Tags
  TAGS_EDIT_ACR: combineOpsNaviACRWithPrefix(70), // Able to edit ACR
  TAGS_CREATE_TAGS: combineOpsNaviACRWithPrefix(71), // Able to create tags
  TAGS_VIEW_TAGS: combineOpsNaviACRWithPrefix(72), // Able to view tags
  TAGS_EDIT_TAGS: combineOpsNaviACRWithPrefix(73), // Able to edit tags
  TAGS_DELETE_TAGS: combineOpsNaviACRWithPrefix(74), // Able to delete tags
  SCORE_CARD_READ_ALL_SCORE_CARDS: combineOpsNaviACRWithPrefix(44), // Read all score cards
  SCORE_CARD_READ_ASSIGNED_SCORE_CARDS: combineOpsNaviACRWithPrefix(45), // Read only assigned score cards
  SCORE_CARD_EDIT_ALL_SCORE_CARDS: combineOpsNaviACRWithPrefix(46), // Edit all score cards
  SCORE_CARD_EDIT_ASSIGNED_SCORE_CARDS: combineOpsNaviACRWithPrefix(47), // Edit only assigned score cards
};
